import React, { MutableRefObject } from 'react';
import { SwipeableHandlers } from 'react-swipeable';
import { Slide } from '@material-ui/core';

import { Player, Spinner } from '../../../../../components';
import { DocumentSignedURL } from '../../../../../types/main';
import MediaPreviewStyles from './styles';

type Props = {
  signedUrl: DocumentSignedURL | undefined;
  swipeable?: SwipeableHandlers;
  slideDirection: 'left' | 'right' | 'up' | 'down';
  isChangePreviewMedia: number | null;
  refPreviewContent: MutableRefObject<HTMLDivElement | null>;
};

const MediaAudio = ({ signedUrl, swipeable, slideDirection, isChangePreviewMedia, refPreviewContent }: Props) => {
  const classes = MediaPreviewStyles();

  return (
    <Slide
      direction={slideDirection}
      in={isChangePreviewMedia === null}
      mountOnEnter
      unmountOnExit
      timeout={300}
    >
      {
        signedUrl === undefined
          ? (
            <div {...swipeable} className={classes.wrapper}>
              <Spinner />
            </div>
          )
          : (
            <div style={{ height: '100%', width: '100%' }}>
              <Player src={signedUrl.url} media="audio" swipeable={swipeable} refPreviewContent={refPreviewContent} />
            </div>
          )
      }
    </Slide>
  );
};

export default MediaAudio;
